import * as React from 'react';

import { Card } from '@blueprintjs/core';

import CardContainer from '../common/CardContainer';

class CompaniesPage extends React.Component<{}> {
    public render() {
        return (
            <>
                <CardContainer height="400px">
                    <Card elevation={1}>
                        <div className="card-header">Companies</div>
                    </Card>
                </CardContainer>
            </>
        );
    }
}

export default CompaniesPage;



// WEBPACK FOOTER //
// ./src/components/companies/CompaniesPage.tsx